import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  CustomCollapseCard,
  CustomImage,
  CustomPopover,
  Text,
  warningDialog,
} from '@src/components';
import { useMediaQuery } from '@src/hooks/useMediaQuery';

import { Button, Radio, Space } from 'antd';

import 'swiper/css/bundle';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

import CreditCards from './CreditCards';

import { setPayWithLinkinEmail, setSelectStoredCard } from '@src/store/slice/mobilExpressSlice';
import { instructionAdd, nextStep, prevStep } from '@src/store/slice/autoUploadInstructionsSlice';

import classNames from 'classnames';

import iconBack from '@src/assets/icons/icon-back.svg';
import iconInfo from '@src/assets/icons/icon-bilgi.svg';

import '@src/styles/autoUploadInstruction/paymentType.scss';

const SavedCreditCards = ({ handleAnotherCreditCard }) => {
  const isMobil = useMediaQuery({ query: '(max-width: 1199.98px)' });

  const dispatch = useDispatch();

  const { storedCard, selectedStoredCard } = useSelector((state) => state?.mobilExpress);
  const { totalAutoLoading, integrationId, autoLoadingId } = useSelector(
    (state) => state?.autoUploadInstructions,
  );

  const [itHasDefaultFlag, setItHasDefaultFlag] = useState(false);
  const showPayLater = false;
  const afterMount = false;

  const activeCard = useMemo(() => {
    dispatch(setSelectStoredCard(null));
    if (storedCard.length === 0) {
      return {};
    }
    const defaultFlag = storedCard.find((s) => s.unlimited_Contract && s.default_Flag);
    dispatch(setPayWithLinkinEmail(false));
    if (defaultFlag?.cardToken) {
      setItHasDefaultFlag(true);
      dispatch(setSelectStoredCard(defaultFlag?.cardToken));
    }
    return defaultFlag;
  }, [storedCard]);

  const storedCardFilter = useMemo(() => {
    return storedCard.filter((s) => s.cardToken !== activeCard?.cardToken);
  }, [activeCard]);

  const onChange = (e) => {
    dispatch(setSelectStoredCard(e.target.value));
    dispatch(setPayWithLinkinEmail(false));
  };

  const handleOrderBack = useCallback(async () => {
    await dispatch(prevStep());
  }, [dispatch]);

  if (storedCard.length === 0) {
    return null;
  }

  const marginTop = () => {
    if (activeCard) return '41px';
    return isMobil ? '25px' : '0';
  };

  const handlePayment = async () => {
    const body = {
      autoLoadingCreateRequestDto: {
        periodType: totalAutoLoading?.periodType,
        confirmEveryMonth: totalAutoLoading?.confirmEveryMonth,
        startDay: totalAutoLoading?.startDay,
        orderProcessType: totalAutoLoading?.orderProcessType,
        monthChoice: totalAutoLoading?.chooseMonth,
        cardToken: selectedStoredCard,
        paymentType: totalAutoLoading?.paymentType,
      },
    };

    if (integrationId && integrationId > 0) {
      body.integrationId = integrationId;
    }

    if (autoLoadingId && autoLoadingId > 0) {
      body.autoLoadingId = totalAutoLoading?.id;
    }

    const action = await dispatch(instructionAdd(body));

    if (instructionAdd.fulfilled.match(action)) {
      dispatch(nextStep());
    }
  };

  return (
    <>
      <ParentElement handleRegisteredCreditCard={handleAnotherCreditCard}>
        <>
          {activeCard && (
            <>
              <div className="unlimited-card-text">
                <Text t="yourCardWithAutomaticPaymentInstruction" />
              </div>
              {isMobil ? (
                <div className="unlimited-card">
                  <Radio.Group
                    id="ticketRestaurant-balanceUpload-payment-savedCreditCards-custom-radioGroup-credit-card"
                    onChange={onChange}
                    value={selectedStoredCard}
                    className="custom-radio-input-credit-card"
                  >
                    <CreditCards cardItem={activeCard} />
                  </Radio.Group>
                </div>
              ) : (
                <div className="unlimited-card">
                  <div className="credit-card-list d-flex">
                    <Radio.Group
                      id="ticketRestaurant-balanceUpload-payment-savedCreditCards-custom-radioGroup-credit-card2"
                      onChange={onChange}
                      value={selectedStoredCard}
                      className="custom-radio-input-credit-card"
                    >
                      <div key={'credit-card-list-radio-group'}>
                        <Space direction="horizontal">
                          <CreditCards cardItem={activeCard} />
                        </Space>
                      </div>
                    </Radio.Group>
                  </div>
                </div>
              )}
            </>
          )}

          {storedCardFilter.length > 0 && (
            <>
              {!!activeCard && <hr className={'stored-cards-line'} />}
              <div
                className={'stored-cards-text'}
                style={{
                  marginTop: marginTop(),
                }}
              >
                {itHasDefaultFlag ? <Text t="otherRegisteredCards" /> : <Text t="registeredCards" />}
              </div>
            </>
          )}

          {isMobil === true ? (
            <Radio.Group
              id="ticketRestaurant-balanceUpload-payment-savedCreditCards-custom-radioGroup-credit-card3"
              onChange={onChange}
              value={selectedStoredCard}
              className="custom-radio-input-credit-card"
            >
              <Swiper
                slidesPerView="auto"
                slideToClickedSlide={true}
                spaceBetween={isMobil ? 16 : 40}
                className="mySwiper stored-card-wrapper"
              >
                {storedCardFilter.map((item, index) => {
                  return (
                    <SwiperSlide key={item?.id}>
                      <CreditCards cardItem={item} />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </Radio.Group>
          ) : (
            <div className="credit-card-list">
              <Radio.Group
                id="ticketRestaurant-balanceUpload-payment-savedCreditCards-custom-radioGroup-credit-card4"
                onChange={onChange}
                value={selectedStoredCard}
                className="custom-radio-input-credit-card"
              >
                <div className="" key={'credit-card-list-radio-group'}>
                  <div className="stored-card-wrapper">
                    {storedCardFilter.map((item, index) => {
                      return (
                        <div className="" key={item?.id}>
                          <CreditCards cardItem={item} />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Radio.Group>
            </div>
          )}
        </>
      </ParentElement>

      <div className="autoUploadInstruction-payment-credit-card-information">
        <div className="autoUploadInstruction-payment-credit-card-information-icon">
          <CustomImage src={iconInfo} />
        </div>
        <div className="autoUploadInstruction-payment-credit-card-information-description">
          <span>
            <Text t="fromTheCardYouSelectedTheTotalAmount" />
          </span>
        </div>
      </div>

      {afterMount && (
        <div className="d-flex pay-with-email">
          <CustomImage src={iconInfo} />{' '}
          <span style={{ marginLeft: '8px' }}>
            <Text t="fromTheCardYouSelectedTheTotalAmount2" />
          </span>
        </div>
      )}
      {!isMobil && (
        <div className={'pay-buttons-where-under-page'}>
          <div className="step-btn-container">
            <Button
              id="balanceUpload-payment-savedCreditCards-back-btn"
              className="back-btn"
              onClick={handleOrderBack}
            >
              <CustomImage src={iconBack} />
              <Text t="turnBack" />
            </Button>
          </div>
          {showPayLater && !afterMount && (
            <>
              <div
                className={classNames({
                  'pay-when-balance-active-day-button': true,
                })}
                onClick={async () => {
                  if (!selectedStoredCard) {
                    return warningDialog({
                      title: 'Uyarı',
                      message: 'Lütfen kayıtlı kartlarınızdan birini seçiniz',
                    });
                  }
                  await window.payWhenBalanceActiveDay();
                }}
              >
                <Text t="payOnBalanceActivationDate" />
              </div>
              <CustomPopover
                placement="topRight"
                title={false}
                content={
                  <div
                    style={{
                      width: '300px',
                      color: '#3f4957',
                      padding: '7px 18px',
                    }}
                  >
                    <Text t="ifYouSelectThisOptionTheTotalBalance2" />
                  </div>
                }
                trigger="hover"
                arrowPointAtCenter={true}
              >
                <div style={{ marginRight: '24px' }}>
                  <CustomImage src={iconInfo} />
                </div>
              </CustomPopover>
            </>
          )}
          <Button
            id="balanceUpload-payment-savedCreditCards-payment-btn"
            disabled={!selectedStoredCard}
            onClick={handlePayment}
            className="payment-btn"
          >
            <Text t="continue" />
          </Button>
        </div>
      )}
    </>
  );
};

export default SavedCreditCards;

const ParentElement = ({ children, handleRegisteredCreditCard }) => {
  return (
    <div className={'saved-credit-cards-card'}>
      <CustomCollapseCard
        headerRightInfo={
          <div className="header-btn" onClick={handleRegisteredCreditCard}>
            <Text t="iWantToPayWithAnotherCard" />
          </div>
        }
        cardTitle={
          <div className="title">
            <Text t="savedCreditCardsTitle" />
          </div>
        }
      >
        <div className="custom-card-body">
          <div className="credit-cards-list-content">{children}</div>
        </div>
      </CustomCollapseCard>
    </div>
  );
};
